<template lang="html">
  <div class="share" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/backShare.png` +')'}">
    <div class="informerBtn" @click="informerShow = 1">
      <p>一键举报</p>
    </div>

    <!-- 轮播 -->
    <div class="shareCard" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/card.png` +')'}">
      <div class="swiperCon swiperConNo3">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(a, aIndex) in activityInfoData.poster_cover" :key="aIndex">
            <PosterWithQRCode :imgUrl="a" :QRCodeMsg="shareUrl" />
          </div>
        </div>
      </div>

      <div class="downPoster">
        <img :src="`${pagebase}/static/img/assistance/icon3.png`" alt="">
        <p>长按海报下载到相册</p>
      </div>

      <div class="downText">
        <div class="downTextTitle">
          <p>单击下方文本复制</p>
          <img :src="`${pagebase}/static/img/assistance/icon2.png`" alt="">
        </div>

        <div class="change" v-show="activityInfoData.recommendation.length >= 2" @click="getChange">
          <img :src="`${pagebase}/static/img/assistance/icon4.png`" alt="">
          <p>换一换</p>
        </div>
      </div>

      <div class="randomTxt" v-for="(b, bIndex) in activityInfoData.recommendation" :key="bIndex" v-show="cur == bIndex" @click="copeText($event)">
        <p> <span>{{b}}</span> </p>
      </div>

      <div class="shareMod">
        <div class="shareBtn" @click="activityShare">
          立即分享
        </div>
      </div>
    </div>

    <div class="informerHint" v-show="informerShow == 1" @click.self="informerShow = 0">
      <div class="informerCon">
        <p class="informerInfo">已收到您的反馈，客服会尽快<br>与您取得联系</p>
        <p class="informerClose" @click="informerShow = 0">我知道了</p>
      </div>
    </div>

    <!-- <div class="shareHint" v-show="shareHintShow == 1" @click="shareHintShow = 0">
      <img src="../../assets/image/customActivity/icguide_ic.png" alt="">
    </div> -->

    <!-- 提示框 -->
    <div v-show="hintShow" class="hintMod">
      <p>{{hintCon}}</p>
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper/swiper-bundle.min.js';
  import 'swiper/swiper-bundle.min.css';
  import {
    pagebase
  } from '@/utils/http.js';
  import WxShare from '@/utils/wxshare';
  import PosterWithQRCode from '@/components/PosterWithQRCode';
  import Cookies from 'js-cookie';
  import utils from '@/utils/utils';

  export default {
    data() {
      return {
        activityId: this.$route.query.aid,
        channelId: this.$route.query.channel || 0,
        activityInfoData: {
          recommendation: [],
        },

        pagebase: pagebase,
        imageUrl: require("@/assets/image/DClogo.png"),
        cur: 0,
        informerShow: 0,
        shareHintShow: 0,
        shareUrl: '',

        hintTime: 1,
        hintShow: false,
        hintCon: '',
      }
    },

    components: {
      PosterWithQRCode,
    },

    mounted() {
      this.init();
    },

    methods: {
      init() {
        this.getActivityInfo();

        this.getSwiper();

        this.shareUrl = pagebase + '/#/customActivityInvite?inviteUid='+ Cookies.get('uid') +'&aid=' + this.activityId + '&channel=' + this.channelId;
      },

      getActivityInfo() {
        this.$http({
          url: '/api/getH5ActivityInfo',
          method: 'get',
          params: {
            uid: Cookies.get('uid') || '',
            token: Cookies.get('token') || '',
            activity_id: this.activityId,
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.activityInfoData = res.data;

            if (utils.browserChecker.isWx()) {
              if (this.activityInfoData.type == 1) {
                new WxShare().share({
                  title: this.activityInfoData.title,
                  desc: '海量资料免费领~',
                  link: pagebase + '/#/customActivityInvite?inviteUid='+ Cookies.get('uid') +'&aid=' + this.activityId + '&channel=' + this.channelId,
                  imgUrl: this.activityInfoData.cover,
                });
              } else if (this.activityInfoData.type == 3){
                new WxShare().share({
                  title: this.activityInfoData.title,
                  desc: '邀请好友，分享得好礼，快来帮我助力',
                  link: pagebase + '/#/customActivityInvite?inviteUid='+ Cookies.get('uid') +'&aid=' + this.activityId + '&channel=' + this.channelId,
                  imgUrl: this.activityInfoData.cover,
                });
              }
            }
          }
        })
      },

      copeText(e) {
        const input = document.createElement('input')
        document.body.appendChild(input)
        input.setAttribute('value', e.target.textContent)
        input.select()
        if (document.execCommand('copy')) {
          document.execCommand('copy')
        }
        document.body.removeChild(input)
        this.setHintCon('文本内容已复制')
      },

      getSwiper() {
        new Swiper(".swiperConNo3", {
          slidesPerView: 1.4,
          spaceBetween: 1,
          centeredSlides: true,
        });
      },

      setHintCon(e) {
        window.clearInterval(this.timers)
        this.hintCon = e;
        this.hintShow = true;
        this.timers = window.setInterval(() => {
          this.hintTime--
          if (this.hintTime < 0) {
            window.clearInterval(this.timers)
            this.hintShow = false
            this.hintTime = 1
          }
        }, 1000)
      },

      activityShare() {
        if (utils.browserChecker.isWx()) {
          // this.shareHintShow = 1;
          this.setHintCon('长按下载海报分享好友助力')
        } else if (utils.browserChecker.isElecnest()) {
          utils.communicateToNative('showShare', {
            message: this.activityInfoData.title,
            picture: this.activityInfoData.cover,
            url: pagebase + '/#/customActivityInvite?aid=' + this.activityId + '&channel=' + this.channelId,
            description: '分享得好礼，快来帮我助力',
          });
        }
      },

      getChange() {
        this.cur = ++this.cur
        if (this.cur >= this.activityInfoData.recommendation.length) {
          this.cur = 0;
          return;
        }
      },
    }
  }
</script>

<style lang="css" scoped>
  .share {
    height: 77.2rem;
    box-sizing: border-box;
    padding: 0 1.5rem;
    background-size: 100% 100%;
    padding-top: 1.35rem;
    padding-bottom: 2.75rem;
  }

  .informerBtn {
    display: flex;
    justify-content: flex-end;
  }

  .informerBtn p {
    width: 8rem;
    height: 2.5rem;
    background-color: rgba(255, 255, 255, 0.5);
    font-size: 1.4rem;
    color: #F22D0A;
    margin-right: -1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2.5rem 0 0 2.5rem;
  }

  .shareCard {
    box-sizing: border-box;
    background-size: 100% 100%;
    height: 69.3rem;
    margin-top: 1rem;
    padding-top: 2rem;
    border-radius: 1rem;
    overflow: hidden;
  }

  .swiper {
    box-sizing: border-box;
    padding: 0 5rem;
    height: 40rem;
    border-radius: 1rem;

    overflow: hidden;
  }

  .swiper-wrapper {
    width: 100%;
  }

  .swiper-slide {
    width: 25rem;
    height: 40rem;
    transform: scale(0.8);
    border-radius: .5rem;
    overflow: hidden;
  }

  .swiper-slide-active,
  .swiper-slide-duplicate-active {
    transform: scale(1);
    border-radius: .5rem;
    overflow: hidden;
  }

  .downPoster {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
    font-size: 1.3rem;
    color: #333333;
  }

  .downPoster img {
    width: 1.35rem;
    height: 1.35rem;
    margin-right: .2rem;
  }

  .downText {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.05rem;
    margin-top: 1.55rem;
  }

  .downTextTitle {
    display: flex;
    align-items: center;
    font-size: 1.35rem;
    color: #333333;
    font-weight: 600;
  }

  .downTextTitle img {
    height: .8rem;
    margin-left: .5rem;
  }

  .change {
    width: 6rem;
    display: flex;
    font-size: 1.3rem;
    color: #FF5A0D;
  }

  .change img {
    height: 1.5rem;
  }

  .randomTxt {
    margin-top: .5rem;
    box-sizing: border-box;
    padding: 0 1rem;
  }

  .randomTxt p {
    box-sizing: border-box;
    height: 9.6rem;
    padding: 1rem;
    line-height: 2.5rem;
    background-size: 100% 100%;
    font-size: 1.3rem;
    color: #444444;
    overflow: auto;
    background-color: #FFF5E8;
  }

  .randomTxt p span {
    border-bottom: .1rem dashed #EA1A14;
  }

  .shareMod {
    box-sizing: border-box;
    margin-top: 3.9rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.3rem;
    color: #333333;
    padding: 0 1.5rem;
  }

  /* 分享 */
  .shareBtn {
    width: 100%;
    height: 4.5rem;
    background: linear-gradient(#F7443F, #EA1A14);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.8rem;
    border-radius: 4.5rem;
    color: #FFF;
  }

  /* 举报 */
  .informerHint {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .informerCon {
    width: 30rem;
    height: 19.3rem;
    background-color: #FFFFFF;
    border-radius: 1rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .informerInfo {
    font-size: 1.6rem;
    color: #1D2023;
  }

  .informerClose {
    width: 22.6rem;
    height: 4.4rem;
    background: linear-gradient(170deg, #FFCC76, #FF9A4D);
    margin-top: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4.4rem;
    color: #642207;
    font-size: 1.8rem;
    font-weight: 600;
  }

  /* 分享 */
  .shareHint {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 10;
    padding: 0 4.4rem;
  }

  .shareHint img {
    margin-top: 2rem;
    width: 100%;
  }

  /* 提示 */
  .hintMod {
    box-sizing: border-box;
    position: fixed;
    bottom: 45%;
    left: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    z-index: 100;
  }

  .hintMod p {
    box-sizing: border-box;
    padding: 0 1.5rem;
    background-color: rgba(0, 0, 0, 0.5);
    font-size: 1.3rem;
    color: #FFFFFF;
    max-width: 65%;
    height: 4rem;
    border-radius: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>